import type { ReactNode } from 'react';
import { Chip } from '@jotpsych/ui';
import { Box, Stack, Typography } from '@mui/material';

import { cardSx } from '../shell/tokens';

/** Status copy and content are supplied by the owner; this view never advances the journey. */
export function IntakeJourneyStatus({
  title,
  statusLabel,
  children,
  action,
}: {
  title: string;
  statusLabel: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Stack spacing={2} sx={cardSx}>
      <Box>
        <Chip label={statusLabel} variant="soft" size="small" />
      </Box>
      <Typography variant="h5" component="h2">
        {title}
      </Typography>
      {children}
      {action && <Box>{action}</Box>}
    </Stack>
  );
}
